/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Mode_ServerInputs */



/**
* | output |
* | --- |
* | "Server" |
*
* @param {Embed_Captions_Mode_ServerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_mode_server = /** @type {((inputs?: Embed_Captions_Mode_ServerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Mode_ServerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Serveur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Server")
	if (locale === "it") return /** @type {LocalizedString} */ ("Server")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сервер")
	if (locale === "es") return /** @type {LocalizedString} */ ("Servidor")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("服务器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サーバ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सर्वर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Servidor")
	return /** @type {LocalizedString} */ ("Server")
});